import styled, { css } from "styled-components";

const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 20 rem;
  ${(props) =>
    props.type === "regular" &&
    css`
      padding: 2.4rem 4rem;

      /* Box */

      background-color: rgba(255, 255, 255, 0.13);
      backdrop-filter: blur(10px);
      border: 1px solid var(--color-grey-100);
      border-radius: var(--border-radius-md);
      box-shadow: var(--shadow-main);
    `}

  ${(props) =>
    props.type === "modal" &&
    css`
      width: auto;
      padding: 2.4rem 4rem;
    `}
    
  overflow: hidden;
  font-size: 1.4rem;
`;

Form.defaultProps = {
  type: "regular",
};

export default Form;
